/** Keep explicitly branded SEO titles intact in both static HTML and SPA navigation. */
export function formatSEOTitle(title: string): string {
  // <!-- SEO: the supplied Name Wheel titles must not gain a second brand suffix. -->
  return /TheNameWheel|^Name Wheel\b|\|\s*Name Wheel$/.test(title)
    ? title
    : `${title} | TheNameWheel`;
}
